import { isWeb } from './isWeb';

export const isApp = () => !isWeb;
